import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { colors } from "../../../enums";
import * as _ from "../../../util/lodash";
import { removeProps } from "../../core/hoc";
import { compose } from 'react-recompose';
import Label from "../../core/label"; //called during the initial render process of the component to generate the truncated DOM output
//(this.props.refs.childRef, this.props.showMoreCharacter, this.props.maxLines) + forceCharTruncate
//Warning: "forceCharTruncate" is used for testing ONLY !!!

var getTruncatedOutput = function getTruncatedOutput(element, showMoreCharacter, maxLines, lineHeight, forceCharTruncate) {
  var textProp = element.textContent === undefined ? 'innerText' : 'textContent';
  var text = element[textProp];
  text = text.replace(/[\r\n]/g, ' '); // determine if text exceeds max height based on maxLines, and if so where to truncate

  var chars = text.split('');
  var upper = chars.length;
  var lower = 0;
  var pivot = 0;

  while (lower < upper) {
    pivot = lower + upper + 1 >> 1;
    element[textProp] = _sliceInstanceProperty(chars).call(chars, 0, pivot).join('');
    element.insertAdjacentHTML('beforeend', showMoreCharacter);

    if (element.offsetHeight > lineHeight * maxLines) {
      upper = pivot - 2;
    } else {
      lower = pivot;
    }
  } //For testing ONLY !
  //This will cause the text to be truncated on collapse by 3 chars


  if (forceCharTruncate) {
    upper -= forceCharTruncate;
  }

  element[textProp] = _sliceInstanceProperty(chars).call(chars, 0, upper).join(''); // don't display showMoreCharacter if we've truncated whitespace but kept all characters

  if (upper < chars.length) element.insertAdjacentHTML('beforeend', showMoreCharacter);
  return element[textProp];
};
/**
 * This component determines if the formatted contents of the children exceeds a given height, and if so condenses and
 * truncates the contents of the children. A show more/show less label is provided when truncation occurs.
 *
 * NOTE: Extra whitespace (i.e. newlines) and any html formatting are stripped in the truncated output, but preserved
 * in the expanded or untruncated output.
 */
//TODO: [Victor] this will need to trigger some sort of re-rendering of the component if we decide to dynamically allow some component props to change as the truncation calculation process gets called only on initial render


var Truncate = createComponent({
  displayName: 'Truncate',
  propTypes: {
    onTruncationChange: PropTypes.func,
    showLessLabel: PropTypes.string,
    showMoreLabel: PropTypes.string,
    showMoreCharacter: PropTypes.string,
    maxLines: PropTypes.number,
    hideCollapseControl: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    //WARNING: used for testing ONLY !!!
    forceCharTruncate: PropTypes.number
  },
  defaultProps: {
    onTruncationChange: _.noop,
    showLessLabel: 'Show Less',
    showMoreLabel: 'Show More',
    showMoreCharacter: '...',
    maxLines: 2,
    hideCollapseControl: false,
    width: '100%',
    forceCharTruncate: undefined
  },
  state: {
    //we need it expanded at first so that we can get the html child element and parse it
    isExpanded: true,
    shouldTruncate: false,
    truncatedOutput: ''
  },
  refs: 'childRef',
  lifecycles: {
    componentDidMount: function componentDidMount() {
      var refStyles = window.getComputedStyle(this.props.refs.childRef);
      var shouldTruncate = _parseInt(refStyles.height, 10) > _parseInt(refStyles.lineHeight, 10) * this.props.maxLines;

      if (shouldTruncate) {
        var truncatedOutput = getTruncatedOutput(this.props.refs.childRef, this.props.showMoreCharacter, this.props.maxLines, _parseInt(refStyles.lineHeight, 10), this.props.forceCharTruncate);
        this.props.setTruncatedOutput(truncatedOutput);
        this.props.setIsExpanded(false);
        this.props.setShouldTruncate(true);
      } else {
        this.props.setShouldTruncate(false);
      }
    },
    componentDidUpdate: function componentDidUpdate(prevProps) {
      if (prevProps.shouldTruncate !== this.props.shouldTruncate || prevProps.isExpanded !== this.props.isExpanded) {
        this.props.onTruncationChange();
      }
    }
  },
  handlers: {
    //collapses or expands the content that needs to be truncated
    toggleCollapse: function toggleCollapse(p) {
      return function (e) {
        e.stopPropagation();
        p.setIsExpanded(!p.isExpanded);
      };
    }
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    //in case a wrapper we can provide some limited width rules
    var _width = typeof p.width === 'number' ? p.width + 'px' : p.width;

    return /*#__PURE__*/React.createElement("div", {
      className: "ck truncate",
      style: {
        width: _width
      }
    }, p.isExpanded ? [/*#__PURE__*/React.createElement("div", {
      className: "ck-truncate__content",
      key: "0"
    }, /*#__PURE__*/React.createElement("div", {
      ref: p.setChildRef
    }, p.children)), p.shouldTruncate && !p.hideCollapseControl ? /*#__PURE__*/React.createElement(Label, {
      text: p.showLessLabel,
      onClick: p.toggleCollapse,
      color: colors.ACCENT,
      style: {
        fontSize: '1em',
        marginLeft: 0
      },
      isFluid: true,
      key: "1"
    }) : null] : [/*#__PURE__*/React.createElement("div", {
      className: "ck-truncate__content",
      key: "0"
    }, p.truncatedOutput), p.shouldTruncate && !p.hideCollapseControl ? /*#__PURE__*/React.createElement(Label, {
      text: p.showMoreLabel,
      onClick: p.toggleCollapse,
      color: p.isInverted ? colors.ACCENT : colors.DARK,
      style: {
        fontSize: '1em',
        marginLeft: 0
      },
      isFluid: true,
      key: "1"
    }) : null]);
  }
});
export var PrivateTruncate = Truncate;
export default compose(removeProps(['forceCharTruncate']))(Truncate);
//# sourceMappingURL=index.js.map